let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("gaUC1")]).then(() => parcelRequire('k8aVR'));